/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Check_VerificationInputs */

const en_login_error_check_verification = /** @type {(inputs: Login_Error_Check_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to check verification status. Please try again.`)
};

const fr_login_error_check_verification = /** @type {(inputs: Login_Error_Check_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la vérification du statut. Veuillez réessayer.`)
};

const de_login_error_check_verification = /** @type {(inputs: Login_Error_Check_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Überprüfung des Verifizierungsstatus ist fehlgeschlagen. Bitte versuchen Sie es erneut.`)
};

const it_login_error_check_verification = /** @type {(inputs: Login_Error_Check_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile verificare lo stato di verifica. Riprova.`)
};

const ru_login_error_check_verification = /** @type {(inputs: Login_Error_Check_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось проверить статус подтверждения. Пожалуйста, попробуйте еще раз.`)
};

const es_login_error_check_verification = /** @type {(inputs: Login_Error_Check_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo comprobar el estado de verificación. Inténtalo de nuevo.`)
};

const zh_cn2_login_error_check_verification = /** @type {(inputs: Login_Error_Check_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证状态检查失败，请重试。`)
};

const ja_login_error_check_verification = /** @type {(inputs: Login_Error_Check_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検証ステータスを確認できませんでした。もう一度お試しください。`)
};

const hi_login_error_check_verification = /** @type {(inputs: Login_Error_Check_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सत्यापन स्थिति की जांच करने में विफल। कृपया पुनः प्रयास करें।`)
};

const pt_pt2_login_error_check_verification = /** @type {(inputs: Login_Error_Check_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao verificar o status da verificação. Tente novamente.`)
};

/**
* | output |
* | --- |
* | "Failed to check verification status. Please try again." |
*
* @param {Login_Error_Check_VerificationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_check_verification = /** @type {((inputs?: Login_Error_Check_VerificationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Check_VerificationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_error_check_verification(inputs)
	if (locale === "de") return de_login_error_check_verification(inputs)
	if (locale === "it") return it_login_error_check_verification(inputs)
	if (locale === "ru") return ru_login_error_check_verification(inputs)
	if (locale === "es") return es_login_error_check_verification(inputs)
	if (locale === "zh-CN") return zh_cn2_login_error_check_verification(inputs)
	if (locale === "ja") return ja_login_error_check_verification(inputs)
	if (locale === "hi") return hi_login_error_check_verification(inputs)
	if (locale === "pt-PT") return pt_pt2_login_error_check_verification(inputs)
	return en_login_error_check_verification(inputs)
});